import { render } from "./ClaimsList.vue?vue&type=template&id=cada9476&scoped=true"
import script from "./ClaimsList.vue?vue&type=script&lang=js"
export * from "./ClaimsList.vue?vue&type=script&lang=js"

import "./ClaimsList.vue?vue&type=style&index=0&id=cada9476&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cada9476"]])

export default __exports__